// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/dimensions" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdDimensions } from "./constants";
import type { UseCaseEnvironment, GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdDimensions = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdDimensions,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string,
    environment?: UseCaseEnvironment
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/dimensions`,
      "GET",
      { environment },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsResult
);
